import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppGlobals, Permission } from './Services/app.global';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';

export type PermissionAndDescription = {
  permission: Permission;
  description: string;
};

@Injectable()
export class IesHttpClient {
    private baseURL: string;
    private accessToken: string;

    constructor(private _http: HttpClient, private _appGlobals: AppGlobals) {
        this._appGlobals.accessToken.subscribe(value => this.accessToken = value);
        this.baseURL = '/individualexamscheduler/services/';
    }

    setHeader(): HttpHeaders {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/json');
        headers = headers.set("X-Auth-Token", this.accessToken);
        return headers;
    }

    get(url, urlParams?) {
        if (urlParams) {
            url = url + urlParams;
        }
        const headers = this.setHeader();
        return this._http.get(
            this.baseURL + url,
            { headers, withCredentials: true }
        ) as Observable<any>;
    }

    post(url, requestData) {
        const headers = this.setHeader();
        return this._http.post(
            this.baseURL + url,
            requestData,
            { headers, withCredentials: true }
        ) as Observable<any>;
    }

    patch(url, requestData) {
        const headers = this.setHeader();
        return this._http.patch(
            this.baseURL + url,
            requestData,
            { headers, withCredentials: true }
        ) as Observable<any>;
    }

    put(url, urlParams) {
        const headers = this.setHeader();
        return this._http.put(
            this.baseURL + url,
            urlParams,
            { headers, withCredentials: true }
        ) as Observable<any>;
    }

    delete(url, urlParams?) {
        if (urlParams) {
            url = url + urlParams;
        }
        const headers = this.setHeader();
        return this._http.delete(
            this.baseURL + url,
            { headers, withCredentials: true }
        ) as Observable<any>;
    }

    downloadFile(url, params?) {
        if (params) {
            url = url + params;
        }

        let headers = new HttpHeaders();
        headers = headers.set('X-Auth-Token', this.accessToken);
        headers = headers.delete("Accept");
        const responseType = 'blob';

        return this._http.get(
            this.baseURL + url,
            { headers, responseType }
        );
    }

    getPermissions(): Observable<PermissionAndDescription[]> {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/vnd.redhat.v2+json');

        return this._http.get<PermissionAndDescription[]>(
            '../../ies/api/security/permissions',
            { headers, withCredentials: true }
        );
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/ies-http-client.service.ts